import { AIADefinition } from "./AIA/AIADefinition";
import { AIAQuestionnaireRegister } from "./AIA/AIAQuestionnaireRegister";
import { AIAManagement } from "./AIA/AIAManagement";
import { AssessmentsDefinition } from "./AIA/AssessmentsDefinition";

import { ApplicationEvaluation } from "./Application/ApplicationEvaluation";
import { ApplicationManagement } from "./Application/ApplicationManagement";

import { AccessManagement } from "./Auth/AccessManagement";

import { EPSDefinition } from "./EPS/EPSDefinition";
import { EPSQuestionnaireRegister } from "./EPS/EPSQuestionnaireRegister";
import { EPSManagement } from "./EPS/EPSManagement";

import { ApplicationFlow } from "./Methodology/ApplicationFlow";

import { OrganizationDefinition } from "./Organization/OrganizationDefinition";
import { OrganizationManagement } from "./Organization/OrganizationManagement";

import { PrinciplesDefinition } from "./Principles/PrinciplesDefinition";
import { PrinciplesImpactCalculation } from "./Principles/PrinciplesImpactCalculation";
import { PrinciplesManagement } from "./Principles/PrinciplesManagement";
import { PrinciplesXQuestions } from "./Principles/PrinciplesXQuestions";

import { QuestionsDefinition } from "./Questions/QuestionsDefinition";
import { QuestionsManagement } from "./Questions/QuestionsManagement";

import { SectionsDefinition } from "./Sections/SectionsDefinition";
import { SectionsManagement } from "./Sections/SectionsManagement";

export const Guide = {
	Auth: {
		AccessManagement: AccessManagement,
	},
	AIAs: {
		Definition: AIADefinition,
		Management: AIAManagement,
		Assessments: AssessmentsDefinition,
		QuestionnaireRegister: AIAQuestionnaireRegister,
	},
	EPS: {
		Definition: EPSDefinition,
		Management: EPSManagement,
		QuestionnaireRegister: EPSQuestionnaireRegister,
	},
	Applications: {
		Management: ApplicationManagement,
		Evaluation: ApplicationEvaluation,
	},
	Organizations: {
		Definition: OrganizationDefinition,
		Management: OrganizationManagement,
	},
	Principles: {
		Definition: PrinciplesDefinition,
		Management: PrinciplesManagement,
		PrinciplesXQuestions: PrinciplesXQuestions,
		ImpactCalculation: PrinciplesImpactCalculation,
	},
	Sections: {
		Definition: SectionsDefinition,
		Management: SectionsManagement,
	},
	Questions: {
		Definition: QuestionsDefinition,
		Management: QuestionsManagement,
	},
	Methodology: {
		ApplicationFlow: ApplicationFlow,
	},
};
